export default "/images/envoi-icon.png?9b5bcdf8fc7a69054482f776c2134ac6";